<template>
	<!-- 专访 -->
	<div class="exclusiveView-list">
		<div class="list" v-if="interViewList.length>0">
			<h3>专访列表</h3>
			<div class="itemWrap">
				<item-block
					v-for="item in interViewList"
					:key="item.id"
					:itemContent="item"
					:name="'exclusiveView'"
					:length="length"
				/>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
	import ItemBlock from '../../components/ItemBlock';
	import Banner from '@/components/Banner';
	import Footer from '@/components/Footer';
	import {ExclusiveViewList,ModulesRecommend} from '../../config/interface.js';
	export default{
		components:{
			ItemBlock,
			Footer
		},
		data(){
			return{
				type:1,
				meeting_id:0,
				banner:'',
				interViewList:[],
				length:0
			}
		},
		mounted(){
			this.meeting_id=this.$route.query.id;
			this.banner=this.$route.query.banner
			this.checkInterView();
		},
		methods:{
			//专访列表
			checkInterView(){
				const url=ExclusiveViewList;
				const method='POST';
				let params={
					meeting_id:this.meeting_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.interViewList=data;
						this.length=data.length;
					}
				})
			}
		}
	}
</script>
<style lang="scss">
	.exclusiveView-list{
		position: relative;
		.swiper-img{
			width:100%;
			padding:14px 12px;
			img{
				width:100%;
			}
		}
		.list{
			
			padding:14px 12px;
			padding-bottom:84px;
			h3{
				font-size:17px;
				color:$color-black;
			}
			.item-block:last-child{
				border:0px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/exclusiveView/List.vue